import { render, staticRenderFns } from "./u-btn-outlined-rounded.vue?vue&type=template&id=7013a4f8&scoped=true&"
import script from "./u-btn-outlined-rounded.vue?vue&type=script&lang=js&"
export * from "./u-btn-outlined-rounded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7013a4f8",
  null
  
)

export default component.exports